/**
 * Subimods Support Team — Meet Our Team detail dialog
 * Root: [data-sm-support-team]
 * Docs: SM-SUPPORT-PAGES.md
 */
(function () {
  'use strict';

  var ROOT_SEL = '[data-sm-support-team]';
  var REDUCE_MQ = '(prefers-reduced-motion: reduce)';

  function initRoot(root) {
    if (!root || root.dataset.smTeamReady === '1') return;
    root.dataset.smTeamReady = '1';

    var dialog = root.querySelector('[data-sm-team-dialog]');
    var body = root.querySelector('[data-sm-team-dialog-body]');
    var closeBtn = root.querySelector('[data-sm-team-close]');
    if (!dialog || !body) return;

    var lastTrigger = null;
    var reduceMotion = window.matchMedia(REDUCE_MQ).matches;

    function setOpenState(isOpen) {
      root.classList.toggle('is-dialog-open', isOpen);
      document.documentElement.classList.toggle('sm-support-team-lock', isOpen);
    }

    function closeDialog() {
      if (typeof dialog.close === 'function' && dialog.open) {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
        setOpenState(false);
      }
      if (lastTrigger && typeof lastTrigger.focus === 'function') {
        lastTrigger.focus();
      }
      lastTrigger = null;
      window.setTimeout(function () {
        body.innerHTML = '';
      }, reduceMotion ? 0 : 180);
    }

    function openFromMember(member, trigger) {
      var template = member.querySelector('[data-sm-team-detail]');
      if (!template) return;

      var content = template.content
        ? template.content.cloneNode(true)
        : (function () {
            var wrap = document.createElement('div');
            wrap.innerHTML = template.innerHTML;
            return wrap;
          })();

      body.innerHTML = '';
      body.appendChild(content);
      lastTrigger = trigger || null;

      var title = body.querySelector('.sm-support-team-detail__name');
      if (title) {
        if (!title.id) title.id = 'sm-team-dialog-heading';
        dialog.setAttribute('aria-labelledby', title.id);
      }

      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      setOpenState(true);

      if (closeBtn && typeof closeBtn.focus === 'function') {
        closeBtn.focus();
      }
    }

    root.addEventListener('click', function (event) {
      var openBtn = event.target.closest('[data-sm-team-open]');
      if (openBtn && root.contains(openBtn)) {
        event.preventDefault();
        var member = openBtn.closest('[data-sm-team-member]');
        if (member) openFromMember(member, openBtn);
        return;
      }

      var closeEl = event.target.closest('[data-sm-team-close]');
      if (closeEl && root.contains(closeEl)) {
        event.preventDefault();
        closeDialog();
      }
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeDialog();
    });

    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeDialog();
    });

    dialog.addEventListener('close', function () {
      setOpenState(false);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.classList.contains('is-dialog-open')) {
        closeDialog();
      }
    });
  }

  function initAll() {
    document.querySelectorAll(ROOT_SEL).forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector(ROOT_SEL)
      : null;
    if (root) {
      delete root.dataset.smTeamReady;
      initRoot(root);
    } else {
      initAll();
    }
  });
})();
